"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatOption = void 0;
var react_1 = require("react");
// FORMATTING
var formatOption = function (option) {
    if (option.label) {
        return option.label;
    }
    else if (react_1.isValidElement(option.item)) {
        // If item can be rendered, then prefer that
        return option.item;
    }
    else {
        // Otherwise fall back to value
        return option.value;
    }
};
exports.formatOption = formatOption;
//# sourceMappingURL=SelectUtils.js.map